export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'APPLICATIONS': 'Applications',
            'DASHBOARD'        : {
                'TITLE': 'Summary'
            },
            'ANNOUNCEMENT_CENTER': 'Announcement center',
            'APPROVALS': 'HR form',
            'MYREQUEST': {
                'TITLE': 'My application',
                'BADGE': '0'
            },
            'APPROVALREQUEST': {
                'TITLE': 'Approval center',
                'BADGE': '10'
            },
            'MANAGEMENT': {
              'GROUP_NAME': 'Management',
            },
            'MANAGEDORDER': {
                'TITLE': 'Application management',
                'BADGE': '0'
            },
            'ANNOUNCEMENT_MANAGEMENT': {
              'TITLE': 'Announcement management',
              'BADGE': '0'
            },
            'EMPLOYEE_INFORMATION': {
                'TITLE': 'Employee information',
                'BADGE': '0',
            },
            'SETTING': {
              'GROUP_NAME': 'Setting',
              'WORKING_CALENDAR': 'Working schedule',
              'WORKING_TIME': {
                'TITLE': 'Working time',
                'BADGE': '0',
              } ,
              'HOLIDAY': {
                'TITLE': 'Public holiday',
                'BADGE': '0',
              } ,
              'APPLICATION_FORM': 'HR Application form',
              'APPLICATION_RULE': {
                'TITLE': 'Application form',
                'BADGE': '0',
              },
              'CUT_OFF_TIME': {
                'TITLE': 'Application cut-off time',
                'BADGE': '0',
              },
              'EMAIL_REMINDER': {
                'TITLE': 'System email',
                'BADGE': '0',
              },
              'EMPLOYEE_INFO': 'Employee Information',
              'ANNUAL_LEAVE': {
                'TITLE': 'Annual leave',
                'BADGE': '0',
              }
            },
            'ADMINISTRATOR': {
              'GROUP_NAME': 'System Administration',
              'EMPLOYEE_DATA': {
                'TITLE': 'Employee data',
                'BADGE': '0',
              },
              'AVAILABLE_LEAVE_DATA': {
                'TITLE': 'Annual leave',
                'BADGE': '0',
              },
            }
        }
    }
};
